import * as Constants from "./../../../core/Constants";

import {
  debounce,
  handleEventTargetValue,
  onQuestionInputValueChange,
} from "src/utils";
import { useCallback, useEffect, useState } from "react";

import { CorePropsInterfaces } from "./../../../core/Models";
import { TextField } from "@mui/material";

function QuestionMultilineInput({
  question,
  isDisabled,
  onChange,
}: CorePropsInterfaces.QuestionInputProps) {
  const [fieldValue, setFieldValue] = useState(question.data.userValue);

  const debouncedChange = useCallback(
    debounce(async (evt: any) => {
      onQuestionInputValueChange(question, evt, onChange);
    }, Constants.INPUT_CHANGE_DEBOUNCE_MILLIS),
    [onChange]
  );

  function onInputValueChangeDelayed(evt: any): void {
    handleEventTargetValue(question, evt);
    setFieldValue(evt.target.value);
    debouncedChange(evt);
  }

  useEffect(() => {
    setFieldValue(question.data.userValue);
  }, [question.data.userValue]);

  return (
    <TextField
      data-testid={question.data.code}
      className="gt-MultilineField"
      onChange={onInputValueChangeDelayed}
      value={fieldValue}
      variant="outlined"
      multiline
      maxRows={2}
      disabled={isDisabled}
    />
  );
}

export default QuestionMultilineInput;
